import React from "react"
import { Box, Typography, alpha, useTheme } from "@mui/material"
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import { motion } from "framer-motion"

export interface NoticeProps {
	message: string
	delay?: number
	icon?: React.ReactNode
}

export function Notice({
	message,
	delay = 0.2,
	icon,
}: NoticeProps) {
	const theme = useTheme()

	return (
		<Box
			component={motion.div}
			initial={{ opacity: 0, y: 10 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{
				duration: 0.4,
				delay,
				ease: "easeOut",
			}}
			sx={{
				borderRadius: 2,
				display: "flex",
				alignItems: "flex-start",
			}}
		>

			{icon ?? (
				<InfoOutlinedIcon
					sx={{
						color: theme.palette.info.main,
						mr: 1,
						fontSize: 18,
					}}
				/>
			)}
			<Typography
				variant="body2"
				sx={{
					fontWeight: 500,
					fontSize: "0.85rem",
				}}
			>
				{message}
			</Typography>
		</Box>
	);
}
